import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Clock } from 'lucide-react';
export function TopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="fixed top-0 left-0 w-full bg-brand-red text-white py-2 px-4 z-50 shadow-lg" data-id="element-211">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-bold" data-id="element-212">
        <span className="uppercase tracking-wider" data-id="element-213">
          Questa offerta scade presto
        </span>
        <div className="flex items-center gap-2 bg-black/20 px-3 py-1 rounded-md" data-id="element-214">
          <Clock className="w-4 h-4" data-id="element-215" />
          <span className="font-mono text-lg tracking-widest" data-id="element-216">
            {hours} : {minutes} : {seconds}
          </span>
        </div>
      </div>
    </div>;
}